{
  "LOGIN": {
    "TITLE": "Log ind på kontaktcentret",
    "EMAIL": {
      "LABEL": "E-mail",
      "PLACEHOLDER": "navn{'@'}example.dk",
      "ERROR": "Indtast venligst en gyldig e-mailadresse"
    },
    "PASSWORD": {
      "LABEL": "Adgangskode",
      "PLACEHOLDER": "Adgangskode"
    },
    "API": {
      "SUCCESS_MESSAGE": "Login Lykkedes",
      "ERROR_MESSAGE": "Kunne ikke oprette forbindelse til Woot Server, Prøv igen senere.",
      "UNAUTH": "Brugernavn / adgangskode forkert. Prøv igen.",
      "ACCOUNT_DEACTIVATED": "Din konto er blevet deaktiveret. Kontakt venligst din administrator.",
      "PASSWORD_LOGIN_DISABLED": "Login med adgangskode er deaktiveret for din konto. Log venligst ind med OAuth (f.eks. Google)."
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Login med Google",
      "BUSINESS_ACCOUNTS_ONLY": "Brug venligst din virksomheds e-mailadresse til at logge ind",
      "NO_ACCOUNT_FOUND": "Vi kunne ikke finde en konto til din e-mailadresse."
    },
    "FORGOT_PASSWORD": "Glemt din adgangskode?",
    "CREATE_NEW_ACCOUNT": "Opret ny konto",
    "SUBMIT": "Log Ind"
  }
}
